import router from './libs/router.js'
import App from './views/App.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import './styles/common.css'

Vue.use(VueResource)

// 2016/07/10格式的时间
Vue.filter('date', date => {
  let d = new Date(date)
  let year = d.getFullYear()
  let month = d.getMonth() > 8 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
  let da = d.getDate() > 9 ? d.getDate() : '0' + d.getDate()
  return year + '-' + month + '-' + da
})

Vue.filter('time', time => {
  let t = parseInt(time / 1000 / 60)
  return t + 'min'
})
Vue.filter('timing', time => {
  if (time >= 60000) {
    let t = parseInt(time / 1000 / 60)
    let min = ((t > 9) ? t : ('0' + t))
    var s = parseInt((time - t * 60 * 1000) / 1000)
    let sec = s > 9 ? s : ('0' + s)
    return min + ':' + sec
  } else {
    var t = parseInt(time / 1000)
    return '00:' + ((t > 9) ? t : '0' + t)
  }
})
Vue.filter('filterRecord', (value, arr, id) => {
  let brr
  brr = arr.filter(item => {
    return item.student_id === id
  })
  if (brr.length > 0) {
    return '分数：' + brr[0].score + ' | 评语：' + brr[0].remark
  } else {
    return false
  }
})
Vue.filter('filterState', (value) => {
  let brr
  brr = value.filter(item => {
    return item.class_state === '筹备' || item.class_state === '进行'
  })
  if (brr.length > 0) {
    return brr
  } else {
    return false
  }
})
Vue.filter('filterNav', (arr) => {
  let brr
  if (window.localStorage.topxgun_training_userRole === '3') {
    brr = arr.filter(item => {
      return item.text !== '用户管理'
    })
  } else {
    brr = arr
  }
  return brr
})
router.start(App, '#root')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/